import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import { TextInput } from 'reactGarden/Input'

import * as S from './styled'
import helperMessages from '../utils/helperMessages'

const Document = ({ label, forwardedRef, watch, errors }) => {
  const hasError = !isEmpty(errors.document)
  const isSuccess = watch('document') && !hasError

  return (
    <S.Wrapper>
      <S.Label htmlFor="document">{label}</S.Label>

      <TextInput
        placeholder={label}
        type="text"
        id="document"
        name="document"
        ref={forwardedRef}
        autoFocus
        maxLength="13"
        isSuccess={isSuccess}
        hasError={hasError}
      />

      <S.Message hasError={hasError} isSuccess={isSuccess}>
        {helperMessages('document', '', errors)}
      </S.Message>
    </S.Wrapper>
  )
}

Document.propTypes = {
  label: PropTypes.string.isRequired,
  forwardedRef: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
}

export default forwardRef((props, ref) => (
  <Document {...props} forwardedRef={ref} />
))
